import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import { Fragment, useContext } from 'react';
import { MONTHLY } from 'self-service-api/constants/Terms';
import { MARKETING_CONTACT_DEPRECATED, CONTACT } from 'self-service-api/constants/UnitTypes';
import { PlanBuilderContext } from '../../../context/PlanBuilderContext';
import AdditionalUnitsPicker from '../AdditionalUnitsPicker';
import { useAppSelector } from '../../../reducers';
import { skuSelector } from '../../../selectors/ProductsSelectors';
import { Divider } from '../SharedComponents';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const QuantityPickerContactsLeftAll = ({
  additionalUnitSkuIds,
  setProductLevel,
  trackingSource,
  productLevel
}) => {
  const {
    productConfigurations,
    setProductConfigurations,
    showDiscountedPricesInUnitsPicker,
    queryParamTerm
  } = useContext(PlanBuilderContext);
  const getSelectedAdditionalUnitsQuantity = additionalUnitSkuId => {
    const foundConfig = productConfigurations.find(({
      skuId
    }) => skuId === additionalUnitSkuId);
    return foundConfig ? foundConfig.quantity : 0;
  };
  const setAdditionalUnitQuantity = (quantity, additionalUnitSkuId) => {
    setProductConfigurations(() => {
      const filteredConfigs = productConfigurations.filter(({
        skuId
      }) => skuId !== additionalUnitSkuId);
      if (quantity > 0) {
        filteredConfigs.push(createProductConfig({
          skuId: additionalUnitSkuId,
          quantity
        }));
      }
      return filteredConfigs;
    });
  };
  const quantityPackSkuIds = useAppSelector(state => {
    return additionalUnitSkuIds.filter(skuId => skuSelector(state, {
      skuId
    }).quantityUnit);
  });
  const contactQuantityPackSkuIds = useAppSelector(state => {
    return quantityPackSkuIds.filter(skuId => {
      const unitType = skuSelector(state, {
        skuId
      }).quantityUnit.unitType;
      return unitType === CONTACT || unitType === MARKETING_CONTACT_DEPRECATED;
    });
  });

  // Need to group the marketing contacts in a way that looks nice
  const contactPickerComponents = contactQuantityPackSkuIds.map(quantityPackSkuId => /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(Divider, {
      className: "m-y-7"
    }), /*#__PURE__*/_jsx(AdditionalUnitsPicker, {
      additionalUnitSkuId: quantityPackSkuId,
      additionalUnitQuantity: getSelectedAdditionalUnitsQuantity(quantityPackSkuId),
      setAdditionalUnitQuantity: (quantity, skuId = quantityPackSkuId) => setAdditionalUnitQuantity(quantity, skuId),
      productConfigurations: productConfigurations,
      setActiveProductLevel: setProductLevel,
      queryParamTerm: showDiscountedPricesInUnitsPicker ? queryParamTerm : MONTHLY,
      trackingSource: trackingSource,
      setProductConfigurations: setProductConfigurations,
      productLevel: productLevel
    })]
  }, quantityPackSkuId));
  return /*#__PURE__*/_jsx(_Fragment, {
    children: contactPickerComponents
  });
};
export default QuantityPickerContactsLeftAll;